export default interface IAdvertFile {
  name: string;
  fullPath: string;
  url: string,
};

export function isAdvertFile(file: IAdvertFile | File): file is IAdvertFile {
  return (file as IAdvertFile).url !== undefined;
}